module.exports = __webpack_public_path__ + "static/media/IMG_1133.92b99a84.jpg";